<script setup lang="ts">
import { computed, watch } from 'vue'
import InlineSvg from 'vue-inline-svg'
import TrinityMainNav from '@/layouts/components/TrinityMainNav.vue'
import logoIcon from '@/assets/images/logo-icon.svg'
import logo from '@/assets/images/logo.svg'
import tithelyLogo from '@/assets/images/tithely-logo.svg'
import tithelyLogoFull from '@/assets/images/tithely-logo-full-trinity.svg'

import { useMe } from '@/queries/me'
import { useModalTriggers } from '@/composables/modals'
import TrinityUserNav from '@/layouts/components/TrinityUserNav.vue'
import TrinityChurchNav from '@/layouts/components/TrinityChurchNav.vue'
import TrinityInboxLite from '@/layouts/components/TrinityInboxLite.vue'
import useNavMain from '@/composables/nav/main'
const { data: me, hasGiving } = useMe()
const { homeNav } = useNavMain()
const { handleUrlModalTrigger } = useModalTriggers()
const isPaid = computed(() => {
    return me.value?.organization.paid ?? false
})

const logoHref = computed(() => {
    if (homeNav.value) {
        return homeNav.value.redirect ?? homeNav.value.route ?? '/r/dashboard'
    }
    return hasGiving ? `/account/tithely/sso?redirect=/` : `/r/dashboard`
})

// Trigger modals if user is logged in
watch(
    () => me.value,
    newMe => {
        if (newMe) {
            handleUrlModalTrigger()
        }
    },
    { immediate: true }
)
</script>

<template>
    <header
        class="trinity-header z-[1000] grid h-20 grid-cols-[minmax(0,1fr)_min-content_minmax(0,1fr)] items-center justify-between gap-6 !p-2 md:!px-6 print:hidden">
        <div>
            <a :href="logoHref">
                <template v-if="hasGiving">
                    <InlineSvg
                        :src="tithelyLogo"
                        class="h-9 w-auto text-primary lg:hidden" />
                    <InlineSvg
                        :src="tithelyLogoFull"
                        class="hidden h-9 w-auto text-primary [--text:rgb(var(--sp-color-primary-950))] lg:visible lg:block" />
                </template>
                <template v-else>
                    <InlineSvg
                        :src="logoIcon"
                        class="h-9 w-auto text-primary lg:hidden" />
                    <InlineSvg
                        :src="logo"
                        class="hidden h-9 w-auto text-primary lg:visible lg:block" />
                </template>
            </a>
        </div>

        <TrinityMainNav />

        <div class="flex items-center justify-end">
            <TrinityInboxLite />
            <TrinityChurchNav v-if="isPaid" />
            <TrinityUserNav />
        </div>
    </header>
</template>
